import React from "react";
import TermsOfMain from "./TermsOfMain";
import DotedPart from "../common/DotedPart";

const IndexTermOfUse = () => {
  return <>
    <TermsOfMain />
    <DotedPart className="mt-[20px] md:mt-[89px] mb-[50px] md:mb-[89px]" />
  </>
};

export default IndexTermOfUse;
